import clsx from 'clsx'
import { ClassName } from 'types/props'

import { Select, Space, Typography } from '../../atoms'
import Icon from '../../atoms/Icon'
import LinkIcon from '../linkIcon'
import classes from './index.module.scss'
import { TablePaginationContainer, TablePaginationNavigation } from './index.styles'

export interface TablePaginationParams {
  pageNumber: number
  pageSize: number
  totalRows: number
}

export interface TablePaginationProps extends ClassName {
  onChange: (updatedPagination: TablePaginationParams) => void
  pagination: TablePaginationParams
  variant?: 'legacy' | 'modern'
}

export const TablePagination = ({
  className,
  onChange,
  pagination,
  variant = 'legacy'
}: TablePaginationProps) => {
  const { pageSize } = pagination
  const { pageNumber } = pagination
  const totalPages = Math.ceil(pagination.totalRows / pageSize)
  const totalPageOptions = []
  for (let index = 1; index <= totalPages; index++) totalPageOptions.push(index)

  const canMovePrevious = () => pageNumber > 1
  const canMoveNext = () => totalPages > pageNumber

  const onNext = () => {
    if (canMoveNext()) {
      const updated = { ...pagination }
      updated.pageNumber = pagination.pageNumber + 1
      onChange(updated)
    }
  }

  const onPrevious = () => {
    if (canMovePrevious()) {
      const updated = { ...pagination }
      updated.pageNumber = pagination.pageNumber - 1
      onChange(updated)
    }
  }

  const onPageNumberSelection = (event: any) => {
    const selectedPage = event.target.value
    const updated = { ...pagination }
    updated.pageNumber = Number(selectedPage)
    onChange(updated)
  }

  return (
    <div
      className={clsx(className, {
        [classes.modern]: variant === 'modern'
      })}
    >
      <TablePaginationContainer
        isflex
        alignItems="center"
        className={classes.container}
        flexDirection="row"
      >
        <TablePaginationNavigation isLeftNavigation className={classes.prev}>
          <LinkIcon
            disabled={!canMovePrevious()}
            icon={<Icon name="chevronLeft" size="small" />}
            iconPosition="left"
            text="prev"
            onClick={onPrevious}
          />
        </TablePaginationNavigation>
        <Space
          isflex
          alignItems="center"
          className={classes.selector}
          flexDirection="row"
          flexGrow={1}
          justifyContent="center"
        >
          <Space mx={2}>
            <Typography variant="b3">page</Typography>
          </Space>
          <Select padding="1px" value={pageNumber} width="40px" onChange={onPageNumberSelection}>
            {totalPageOptions.map(option => (
              <option key={option.toString()} value={option.toString()}>
                {option}
              </option>
            ))}
          </Select>
          <Space mx={2}>
            <Typography variant="b3">{`of ${totalPages}`}</Typography>
          </Space>
        </Space>
        <TablePaginationNavigation className={classes.next} isLeftNavigation={false}>
          <LinkIcon
            disabled={!canMoveNext()}
            icon={<Icon name="chevronRight" size="small" />}
            iconPosition="right"
            text="next"
            onClick={onNext}
          />
        </TablePaginationNavigation>
      </TablePaginationContainer>
    </div>
  )
}
